<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()" *ngIf="dialogRef">
        <mat-icon>close</mat-icon>
    </button>

    <div class="img-dictionary mx-auto"></div>

    <h2 class="mat-headline mb-4">{{ 'dialog.dictionary.description'|translate }}</h2>

    <div class="dictionary-wrapper" *ngIf="dictionaries">
        <div class="letters-wrapper">
            <mat-button-toggle-group [(value)]="current">
                <ng-template ngFor let-dictionary [ngForOf]="dictionaries">
                    <mat-button-toggle [value]="dictionary" (click)="onCategoryClick()">{{ dictionary.name }}</mat-button-toggle>
                </ng-template>
            </mat-button-toggle-group>
        </div>
        <div #conceptsWrapper class="concepts-wrapper bg-gray-gradient text-left">
            <ng-container *ngIf="concepts && concepts.length > 0">
                <ng-template ngFor let-concept [ngForOf]="concepts" let-isLast="last">
                    <div [class.mb-3]="!isLast">
                        <h4 class="mat-subheading-1 text-blue font-weight-bold mb-2">{{ concept.concept }}</h4>
                        <p class="text-justify mb-0">{{ concept.definition }}</p>
                    </div>
                </ng-template>
            </ng-container>
            <ng-container *ngIf="!concepts || concepts.length === 0">
                <div>
                    <h4 class="mat-subheading-1 text-blue font-weight-bold mb-2">{{ current?.name }}</h4>
                    <p class="text-justify mb-0">{{ 'dialog.dictionary.no-concepts'|translate }}</p>
                </div>
            </ng-container>
        </div>
    </div>
</div>
